import type { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarProps } from './types';

const Sidebar: FC<SidebarProps> = ({ 
  isLoggedIn, 
  onLogout,
  onLoginClick,
  onContactClick,
  isOpen,
  onClose,
  isAdmin,
  isModerator,
  isLoading,
}) => {
  const navItemClass =
    'cn-nav-item';

  return (
    <>
      {/* Sidebar */}
      <div
        id="sidebar"
        className={`
          fixed left-0 top-0 h-screen pt-[calc(env(safe-area-inset-top,0px)+80px)] cn-sidebar text-slate-100 flex flex-col z-[2147483647] rounded-r-2xl overflow-hidden
          transform transition-all duration-300 ease-in-out
          w-[min(88vw,22rem)] sm:w-72 ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
        onClick={(e) => e.stopPropagation()}
      >
        <div id="sidebar-logo" className="w-full text-center">
          <h2 className="text-lg font-bold tracking-wide" style={{ color: '#ffffff' }}>KiedyCoGdzie.pl</h2>
        </div>
        
        
      
        <div id="sidebar-navigation"
          className="flex-1 overflow-y-auto overflow-x-hidden p-4 space-y-5 rounded-2xl"
          style={{
            WebkitOverflowScrolling: 'touch',
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)'
          }}
        >
          {/* Menu Items */}
          <div id="sidebar-menu" className="space-y-2">
            <NavLink
              id="map-link"
              to="/"
              className={({ isActive }) => `${navItemClass} justify-center text-center ${isActive ? 'cn-nav-item-active' : ''}`}
              onClick={() => {
                onClose();
                window.dispatchEvent(new CustomEvent('closeSubmissionsView'));
                window.dispatchEvent(new CustomEvent('closeRecurringTemplatesView'));
              }}
            >
              Mapa wydarzeń
            </NavLink>
            {isLoggedIn && (isAdmin || isModerator) && !isLoading && (
              <NavLink
                id="submissions-button"
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  window.dispatchEvent(new CustomEvent('openSubmissionsView'));
                }}
                className={`${navItemClass} justify-center text-center`}
              >
                Zgłoszenia
              </NavLink>
            )}
            {isLoggedIn && (isAdmin || isModerator) && !isLoading && (
              <NavLink
                id="recurring-series-button"
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  window.dispatchEvent(new CustomEvent('openRecurringTemplatesView'));
                }}
                className={`${navItemClass} justify-center text-center`}
              >
                Cykle wydarzeń
              </NavLink>
            )}
            <NavLink
              id="add-event-button"
              to="/"
              onClick={(e) => {
                e.preventDefault();
                onClose();
                window.dispatchEvent(new CustomEvent('openAddEventModal'));
              }}
              className={`${navItemClass} justify-center text-center`}
            >
              Dodaj wydarzenie
            </NavLink>
            {isLoggedIn && isAdmin && !isLoading && (
              <NavLink
                id="add-user-button"
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  window.dispatchEvent(new CustomEvent('openAddUserModal'));
                }}
                className={`${navItemClass} justify-center text-center`}
              >
                Dodaj użytkownika
              </NavLink>
            )}
            <NavLink
              id="contact-link"
              to="/"
              className={`${navItemClass} justify-center text-center`}
              onClick={(e) => {
                e.preventDefault();
                onClose();
                onContactClick?.();
                window.dispatchEvent(new CustomEvent('openContactModal'));
              }}
            >
              Kontakt
            </NavLink>
            <NavLink
              id="privacy-policy-link"
              to="/"
              className={`${navItemClass} justify-center text-center`}
              onClick={(e) => {
                e.preventDefault();
                onClose();
                window.dispatchEvent(new CustomEvent('openPrivacyPolicyModal'));
              }}
            >
              Polityka prywatności
            </NavLink>
            <NavLink
              id="terms-link"
              to="/"
              className={`${navItemClass} justify-center text-center`}
              onClick={(e) => {
                e.preventDefault();
                onClose();
                window.dispatchEvent(new CustomEvent('openTermsModal'));
              }}
            >
              Regulamin
            </NavLink>
            {!isLoggedIn && (
              <NavLink
                id="login-button"
                to="/"
                className={`${navItemClass} justify-center text-center`}
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  onLoginClick?.();
                }}
              >
                Zaloguj
              </NavLink>
            )}
            {isLoggedIn && (
              <NavLink
                id="logout-button"
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  onLogout();
                }}
                className={`${navItemClass} justify-center text-center`}
              >
                Wyloguj
              </NavLink>
            )}
          </div>

        </div>
      </div>
    </>
  );
};

export default Sidebar;
